import * as Ce from "react";
function j() {
  return j = Object.assign ? Object.assign.bind() : function(r) {
    for (var i = 1; i < arguments.length; i++) {
      var l = arguments[i];
      for (var u in l) Object.prototype.hasOwnProperty.call(l, u) && (r[u] = l[u]);
    }
    return r;
  }, j.apply(this, arguments);
}
const _e = ["children", "options"], ue = ["allowFullScreen", "allowTransparency", "autoComplete", "autoFocus", "autoPlay", "cellPadding", "cellSpacing", "charSet", "classId", "colSpan", "contentEditable", "contextMenu", "crossOrigin", "encType", "formAction", "formEncType", "formMethod", "formNoValidate", "formTarget", "frameBorder", "hrefLang", "inputMode", "keyParams", "keyType", "marginHeight", "marginWidth", "maxLength", "mediaGroup", "minLength", "noValidate", "radioGroup", "readOnly", "rowSpan", "spellCheck", "srcDoc", "srcLang", "srcSet", "tabIndex", "useMap"].reduce((r, i) => (r[i.toLowerCase()] = i, r), { class: "className", for: "htmlFor" }), ae = { amp: "&", apos: "'", gt: ">", lt: "<", nbsp: " ", quot: "“" }, Me = ["style", "script", "pre"], je = ["src", "href", "data", "formAction", "srcDoc", "action"], He = /([-A-Z0-9_:]+)(?:\s*=\s*(?:(?:"((?:\\.|[^"])*)")|(?:'((?:\\.|[^'])*)')|(?:\{((?:\\.|{[^}]*?}|[^}])*)\})))?/gi, Pe = /mailto:/i, Ue = /\n{2,}$/, fe = /^(\s*>[\s\S]*?)(?=\n\n|$)/, Ie = /^ *> ?/gm, Be = /^(?:\[!([^\]]*)\]\n)?([\s\S]*)/, Fe = /^ {2,}\n/, Ze = /^(?:( *[-*_])){3,} *(?:\n *)+\n/, pe = /^(?: {1,3})?(`{3,}|~{3,}) *(\S+)? *([^\n]*?)?\n([\s\S]*?)(?:\1\n?|$)/, de = /^(?: {4}[^\n]+\n*)+(?:\n *)+\n?/, Ne = /^(`+)((?:\\`|(?!\1)`|[^`])+)\1/, We = /^(?:\n *)*\n/, qe = /\r\n?/g, De = /^\[\^([^\]]+)](:(.*)((\n+ {4,}.*)|(\n(?!\[\^).+))*)/, Ge = /^\[\^([^\]]+)]/, Ve = /\f/g, Je = /^---[ \t]*\n(.|\n)*\n---[ \t]*\n/, Ke = /^\s*?\[(x|\s)\]/, ge = /^ *(#{1,6}) *([^\n]+?)(?: +#*)?(?:\n *)*(?:\n|$)/, he = /^ *(#{1,6}) +([^\n]+?)(?: +#*)?(?:\n *)*(?:\n|$)/, me = /^([^\n]+)\n *(=|-){3,} *\n/, ee = /^ *(?!<[a-z][^ >/]* ?\/>)<([a-z][^ >/]*) ?((?:[^>]*[^/])?)>\n?(\s*(?:<\1[^>]*?>[\s\S]*?<\/\1>|(?!<\1\b)[\s\S])*?)<\/\1>(?!<\/\1>)\n*/i, Qe = /&([a-z0-9]+|#[0-9]{1,6}|#x[0-9a-fA-F]{1,6});/gi, ye = /^<!--[\s\S]*?(?:-->)/, Xe = /^(data|aria|x)-[a-z_][a-z\d_.-]*$/, te = /^ *<([a-z][a-z0-9:]*)(?:\s+((?:<.*?>|[^>])*))?\/?>(?!<\/\1>)(\s*\n)?/i, Ye = /^\{.*\}$/, et = /^(https?:\/\/[^\s<]+[^<.,:;"')\]\s])/, tt = /^<([^ >]+@[^ >]+)>/, nt = /^<([^ >]+:\/[^ >]+)>/, rt = /-([a-z])?/gi, ke = /^(\|.*)\n(?: *(\|? *[-:]+ *\|[-| :]*)\n((?:.*\|.*\n)*))?\n?/, it = /^[^\n]+(?:  \n|\n{2,})/, lt = /^\[([^\]]*)\]:\s+<?([^\s>]+)>?\s*("([^"]*)")?/, ot = /^!\[([^\]]*)\] ?\[([^\]]*)\]/, ct = /^\[([^\]]*)\] ?\[([^\]]*)\]/, st = /(\n|^[-*]\s|^#|^ {2,}|^-{2,}|^>\s)/, ut = /\t/g, at = /(^ *\||\| *$)/g, ft = /^ *:-+: *$/, pt = /^ *:-+ *$/, dt = /^ *-+: *$/, K = (r) => `(?=[\\s\\S]+?\\1${r ? "\\1" : ""})`, Q = "((?:\\[.*?\\][([].*?[)\\]]|<.*?>(?:.*?<.*?>)?|`.*?`|\\\\\\1|[\\s\\S])+?)", gt = RegExp(`^([*_])\\1${K(1)}${Q}\\1\\1(?!\\1)`), ht = RegExp(`^([*_])${K(0)}${Q}\\1(?!\\1)`), mt = RegExp(`^(==)${K(0)}${Q}\\1`), yt = RegExp(`^(~~)${K(0)}${Q}\\1`), kt = /^(:[a-zA-Z0-9-_]+:)/, xt = /^\\([^0-9A-Za-z\s])/, vt = /\\([^0-9A-Za-z\s])/g, bt = /^[\s\S](?:(?!  \n|[0-9]\.|http)[^=*_~\-\n:<`\\\[!])*/, Ct = /^\n+/, $t = /^([ \t]*)/, Ot = /(?:^|\n)( *)$/, oe = "(?:\\d+\\.)", ce = "(?:[*+-])";
function $e(r) {
  return "( *)(" + (r === 1 ? oe : ce) + ") +";
}
const Oe = $e(1), Ae = $e(2);
function Se(r) {
  return RegExp("^" + (r === 1 ? Oe : Ae));
}
const At = Se(1), St = Se(2);
function Te(r) {
  return RegExp("^" + (r === 1 ? Oe : Ae) + "[^\\n]*(?:\\n(?!\\1" + (r === 1 ? oe : ce) + " )[^\\n]*)*(\\n|$)", "gm");
}
const Tt = Te(1), zt = Te(2);
function ze(r) {
  const i = r === 1 ? oe : ce;
  return RegExp("^( *)(" + i + ") [\\s\\S]+?(?:\\n{2,}(?! )(?!\\1" + i + " (?!" + i + " ))\\n*|\\s*\\n*$)");
}
const Ee = ze(1), Le = ze(2);
function xe(r, i) {
  const l = i === 1, u = l ? Ee : Le, d = l ? Tt : zt, m = l ? At : St;
  return { t: (p) => m.test(p), o: I(function(p, c) {
    const f = Ot.exec(c.prevCapture);
    return f && (c.list || !c.inline && !c.simple) ? u.exec(p = f[1] + p) : null;
  }), i: 1, u(p, c, f) {
    const y = l ? +p[2] : void 0, $ = p[0].replace(Ue, `
`).match(d);
    let O = !1;
    return { items: $.map(function(L, Z) {
      const N = m.exec(L)[0].length, W = RegExp("^ {1," + N + "}", "gm"), H = L.replace(W, "").replace(m, ""), e = Z === $.length - 1, n = H.indexOf(`

`) !== -1 || e && O;
      O = n;
      const t = f.inline, s = f.list;
      let o;
      f.list = !0, n ? (f.inline = !1, o = F(H) + `

`) : (f.inline = !0, o = F(H));
      const a = c(o, f);
      return f.inline = t, f.list = s, a;
    }), ordered: l, start: y };
  }, l: (p, c, f) => r(p.ordered ? "ol" : "ul", { key: f.key, start: p.type === "20" ? p.start : void 0 }, p.items.map(function(y, $) {
    return r("li", { key: $ }, c(y, f));
  })) };
}
const Et = RegExp(`^\\[((?:\\[[^\\[\\]]*(?:\\[[^\\[\\]]*\\][^\\[\\]]*)*\\]|[^\\[\\]])*)\\]\\(\\s*<?((?:\\([^)]*\\)|[^\\s\\\\]|\\\\.)*?)>?(?:\\s+['"]([\\s\\S]*?)['"])?\\s*\\)`), Lt = /^!\[(.*?)\]\( *((?:\([^)]*\)|[^() ])*) *"?([^)"]*)?"?\)/;
function F(r) {
  let i = r.length;
  for (; i > 0 && r[i - 1] <= " "; ) i--;
  return r.slice(0, i);
}
function V(r, i) {
  return r.startsWith(i);
}
function Rt(r, i, l) {
  if (Array.isArray(l)) {
    for (let u = 0; u < l.length; u++) if (V(r, l[u])) return !0;
    return !1;
  }
  return l(r, i);
}
function B(r) {
  return r.replace(/[ÀÁÂÃÄÅàáâãäåæÆ]/g, "a").replace(/[çÇ]/g, "c").replace(/[ðÐ]/g, "d").replace(/[ÈÉÊËéèêë]/g, "e").replace(/[ÏïÎîÍíÌì]/g, "i").replace(/[Ññ]/g, "n").replace(/[øØœŒÕõÔôÓóÒò]/g, "o").replace(/[ÜüÛûÚúÙù]/g, "u").replace(/[ŸÿÝý]/g, "y").replace(/[^a-z0-9- ]/gi, "").replace(/ /gi, "-").toLowerCase();
}
function wt(r) {
  return dt.test(r) ? "right" : ft.test(r) ? "center" : pt.test(r) ? "left" : null;
}
function ve(r, i, l, u) {
  const d = l.inTable;
  l.inTable = !0;
  let m = [[]], p = "";
  function c() {
    if (!p) return;
    const f = m[m.length - 1];
    f.push.apply(f, i(p, l)), p = "";
  }
  return r.trim().split(/(`[^`]*`|\\\||\|)/).filter(Boolean).forEach((f, y, $) => {
    f.trim() === "|" && (c(), u) ? y !== 0 && y !== $.length - 1 && m.push([]) : p += f;
  }), c(), l.inTable = d, m;
}
function _t(r, i, l) {
  l.inline = !0;
  const u = r[2] ? r[2].replace(at, "").split("|").map(wt) : [], d = r[3] ? (function(p, c, f) {
    return p.trim().split(`
`).map(function(y) {
      return ve(y, c, f, !0);
    });
  })(r[3], i, l) : [], m = ve(r[1], i, l, !!d.length);
  return l.inline = !1, d.length ? { align: u, cells: d, header: m, type: "25" } : { children: m, type: "21" };
}
function be(r, i) {
  return r.align[i] == null ? {} : { textAlign: r.align[i] };
}
function I(r) {
  return r.inline = 1, r;
}
function z(r) {
  return I(function(i, l) {
    return l.inline ? r.exec(i) : null;
  });
}
function E(r) {
  return I(function(i, l) {
    return l.inline || l.simple ? r.exec(i) : null;
  });
}
function T(r) {
  return function(i, l) {
    return l.inline || l.simple ? null : r.exec(i);
  };
}
function G(r) {
  return I(function(i) {
    return r.exec(i);
  });
}
const Mt = /(javascript|vbscript|data(?!:image)):/i;
function jt(r) {
  try {
    const i = decodeURIComponent(r).replace(/[^A-Za-z0-9/:]/g, "");
    if (Mt.test(i)) return null;
  } catch {
    return null;
  }
  return r;
}
function S(r) {
  return r && r.replace(vt, "$1");
}
function J(r, i, l) {
  const u = l.inline || !1, d = l.simple || !1;
  l.inline = !0, l.simple = !0;
  const m = r(i, l);
  return l.inline = u, l.simple = d, m;
}
function Ht(r, i, l) {
  const u = l.inline || !1, d = l.simple || !1;
  l.inline = !1, l.simple = !0;
  const m = r(i, l);
  return l.inline = u, l.simple = d, m;
}
function Pt(r, i, l) {
  const u = l.inline || !1;
  l.inline = !1;
  const d = r(i, l);
  return l.inline = u, d;
}
const ne = (r, i, l) => ({ children: J(i, r[2], l) });
function re() {
  return {};
}
function ie() {
  return null;
}
function Ut(...r) {
  return r.filter(Boolean).join(" ");
}
function le(r, i, l) {
  let u = r;
  const d = i.split(".");
  for (; d.length && (u = u[d[0]], u !== void 0); ) d.shift();
  return u || l;
}
function It(r = "", i = {}) {
  i.overrides = i.overrides || {}, i.namedCodesToUnicode = i.namedCodesToUnicode ? j({}, ae, i.namedCodesToUnicode) : ae;
  const l = i.slugify || B, u = i.sanitizer || jt, d = i.createElement || Ce.createElement, m = [fe, pe, de, i.enforceAtxHeadings ? he : ge, me, ke, Ee, Le], p = [...m, it, ee, ye, te];
  function c(e, n, ...t) {
    const s = le(i.overrides, e + ".props", {});
    return d((function(o, a) {
      const g = le(a, o);
      return g ? typeof g == "function" || typeof g == "object" && "render" in g ? g : le(a, o + ".component", o) : o;
    })(e, i.overrides), j({}, n, s, { className: Ut(n?.className, s.className) || void 0 }), ...t);
  }
  function f(e) {
    e = e.replace(Je, "");
    let n = !1;
    i.forceInline ? n = !0 : i.forceBlock || (n = st.test(e) === !1);
    const t = N(Z(n ? e : F(e).replace(Ct, "") + `

`, { inline: n }));
    for (; typeof t[t.length - 1] == "string" && !t[t.length - 1].trim(); ) t.pop();
    if (i.wrapper === null) return t;
    const s = i.wrapper || (n ? "span" : "div");
    let o;
    if (t.length > 1 || i.forceWrapper) o = t;
    else {
      if (t.length === 1) return o = t[0], typeof o == "string" ? c("span", { key: "outer" }, o) : o;
      o = null;
    }
    return d(s, { key: "outer" }, o);
  }
  function y(e, n) {
    if (!n || !n.trim()) return null;
    const t = n.match(He);
    return t ? t.reduce(function(s, o) {
      const a = o.indexOf("=");
      if (a !== -1) {
        const g = (function(h) {
          return h.indexOf("-") !== -1 && h.match(Xe) === null && (h = h.replace(rt, function(C, v) {
            return v.toUpperCase();
          })), h;
        })(o.slice(0, a)).trim(), k = (function(h) {
          const C = h[0];
          return (C === '"' || C === "'") && h.length >= 2 && h[h.length - 1] === C ? h.slice(1, -1) : h;
        })(o.slice(a + 1).trim()), x = ue[g] || g;
        if (x === "ref") return s;
        const b = s[x] = (function(h, C, v, se) {
          return C === "style" ? (function(P) {
            const R = [];
            let w = "", _ = !1, q = !1, X = "";
            if (!P) return R;
            for (let M = 0; M < P.length; M++) {
              const A = P[M];
              if (A !== '"' && A !== "'" || _ || (q ? A === X && (q = !1, X = "") : (q = !0, X = A)), A === "(" && w.endsWith("url") ? _ = !0 : A === ")" && _ && (_ = !1), A !== ";" || q || _) w += A;
              else {
                const U = w.trim();
                if (U) {
                  const Y = U.indexOf(":");
                  if (Y > 0) {
                    const Re = U.slice(0, Y).trim(), we = U.slice(Y + 1).trim();
                    R.push([Re, we]);
                  }
                }
                w = "";
              }
            }
            const D = w.trim();
            if (D) {
              const M = D.indexOf(":");
              if (M > 0) {
                const A = D.slice(0, M).trim(), U = D.slice(M + 1).trim();
                R.push([A, U]);
              }
            }
            return R;
          })(v).reduce(function(P, [R, w]) {
            return P[R.replace(/(-[a-z])/g, (_) => _[1].toUpperCase())] = se(w, h, R), P;
          }, {}) : je.indexOf(C) !== -1 ? se(S(v), h, C) : (v.match(Ye) && (v = S(v.slice(1, v.length - 1))), v === "true" || v !== "false" && v);
        })(e, g, k, u);
        typeof b == "string" && (ee.test(b) || te.test(b)) && (s[x] = f(b.trim()));
      } else o !== "style" && (s[ue[o] || o] = !0);
      return s;
    }, {}) : null;
  }
  const $ = [], O = {}, L = { 0: { t: [">"], o: T(fe), i: 1, u(e, n, t) {
    const [, s, o] = e[0].replace(Ie, "").match(Be);
    return { alert: s, children: n(o, t) };
  }, l(e, n, t) {
    const s = { key: t.key };
    return e.alert && (s.className = "markdown-alert-" + l(e.alert.toLowerCase(), B), e.children.unshift({ attrs: {}, children: [{ type: "27", text: e.alert }], noInnerParse: !0, type: "11", tag: "header" })), c("blockquote", s, n(e.children, t));
  } }, 1: { o: G(Fe), i: 1, u: re, l: (e, n, t) => c("br", { key: t.key }) }, 2: { t: (e) => {
    const n = e[0];
    return n === "-" || n === "*" || n === "_";
  }, o: T(Ze), i: 1, u: re, l: (e, n, t) => c("hr", { key: t.key }) }, 3: { t: ["    "], o: T(de), i: 0, u: (e) => ({ lang: void 0, text: S(F(e[0].replace(/^ {4}/gm, ""))) }), l: (e, n, t) => c("pre", { key: t.key }, c("code", j({}, e.attrs, { className: e.lang ? "lang-" + e.lang : "" }), e.text)) }, 4: { t: ["```", "~~~"], o: T(pe), i: 0, u: (e) => ({ attrs: y("code", e[3] || ""), lang: e[2] || void 0, text: e[4], type: "3" }) }, 5: { t: ["`"], o: E(Ne), i: 3, u: (e) => ({ text: S(e[2]) }), l: (e, n, t) => c("code", { key: t.key }, e.text) }, 6: { t: ["[^"], o: T(De), i: 0, u: (e) => ($.push({ footnote: e[2], identifier: e[1] }), {}), l: ie }, 7: { t: ["[^"], o: z(Ge), i: 1, u: (e) => ({ target: "#" + l(e[1], B), text: e[1] }), l: (e, n, t) => c("a", { key: t.key, href: u(e.target, "a", "href") }, c("sup", { key: t.key }, e.text)) }, 8: { t: ["[ ]", "[x]"], o: z(Ke), i: 1, u: (e) => ({ completed: e[1].toLowerCase() === "x" }), l: (e, n, t) => c("input", { checked: e.completed, key: t.key, readOnly: !0, type: "checkbox" }) }, 9: { t: ["#"], o: T(i.enforceAtxHeadings ? he : ge), i: 1, u: (e, n, t) => ({ children: J(n, e[2], t), id: l(e[2], B), level: e[1].length }), l: (e, n, t) => c("h" + e.level, { id: e.id, key: t.key }, n(e.children, t)) }, 10: { o: T(me), i: 0, u: (e, n, t) => ({ children: J(n, e[1], t), level: e[2] === "=" ? 1 : 2, type: "9" }) }, 11: { t: ["<"], o: G(ee), i: 1, u(e, n, t) {
    const [, s] = e[3].match($t), o = RegExp("^" + s, "gm"), a = e[3].replace(o, ""), g = (k = a, p.some((v) => v.test(k)) ? Pt : J);
    var k;
    const x = e[1].toLowerCase(), b = Me.indexOf(x) !== -1, h = (b ? x : e[1]).trim(), C = { attrs: y(h, e[2]), noInnerParse: b, tag: h };
    if (t.inAnchor = t.inAnchor || x === "a", b) C.text = e[3];
    else {
      const v = t.inHTML;
      t.inHTML = !0, C.children = g(n, a, t), t.inHTML = v;
    }
    return t.inAnchor = !1, C;
  }, l: (e, n, t) => c(e.tag, j({ key: t.key }, e.attrs), e.text || (e.children ? n(e.children, t) : "")) }, 13: { t: ["<"], o: G(te), i: 1, u(e) {
    const n = e[1].trim();
    return { attrs: y(n, e[2] || ""), tag: n };
  }, l: (e, n, t) => c(e.tag, j({}, e.attrs, { key: t.key })) }, 12: { t: ["<!--"], o: G(ye), i: 1, u: () => ({}), l: ie }, 14: { t: ["!["], o: E(Lt), i: 1, u: (e) => ({ alt: S(e[1]), target: S(e[2]), title: S(e[3]) }), l: (e, n, t) => c("img", { key: t.key, alt: e.alt || void 0, title: e.title || void 0, src: u(e.target, "img", "src") }) }, 15: { t: ["["], o: z(Et), i: 3, u: (e, n, t) => ({ children: Ht(n, e[1], t), target: S(e[2]), title: S(e[3]) }), l: (e, n, t) => c("a", { key: t.key, href: u(e.target, "a", "href"), title: e.title }, n(e.children, t)) }, 16: { t: ["<"], o: z(nt), i: 0, u: (e) => ({ children: [{ text: e[1], type: "27" }], target: e[1], type: "15" }) }, 17: { t: (e, n) => !n.inAnchor && !i.disableAutoLink && (V(e, "http://") || V(e, "https://")), o: z(et), i: 0, u: (e) => ({ children: [{ text: e[1], type: "27" }], target: e[1], title: void 0, type: "15" }) }, 18: { t: ["<"], o: z(tt), i: 0, u(e) {
    let n = e[1], t = e[1];
    return Pe.test(t) || (t = "mailto:" + t), { children: [{ text: n.replace("mailto:", ""), type: "27" }], target: t, type: "15" };
  } }, 20: xe(c, 1), 33: xe(c, 2), 19: { o: T(We), i: 3, u: re, l: () => `
` }, 21: { o: I(function(e, n) {
    if (n.inline || n.simple || n.inHTML && e.indexOf(`

`) === -1 && n.prevCapture.indexOf(`

`) === -1) return null;
    let t = "";
    e.split(`
`).every((o) => (o += `
`, !m.some((a) => a.test(o)) && (t += o, !!o.trim())));
    const s = F(t);
    return s === "" ? null : [t, , s];
  }), i: 3, u: ne, l: (e, n, t) => c("p", { key: t.key }, n(e.children, t)) }, 22: { t: ["["], o: z(lt), i: 0, u: (e) => (O[e[1]] = { target: e[2], title: e[4] }, {}), l: ie }, 23: { t: ["!["], o: E(ot), i: 0, u: (e) => ({ alt: e[1] ? S(e[1]) : void 0, ref: e[2] }), l: (e, n, t) => O[e.ref] ? c("img", { key: t.key, alt: e.alt, src: u(O[e.ref].target, "img", "src"), title: O[e.ref].title }) : null }, 24: { t: (e) => e[0] === "[" && e.indexOf("](") === -1, o: z(ct), i: 0, u: (e, n, t) => ({ children: n(e[1], t), fallbackChildren: e[0], ref: e[2] }), l: (e, n, t) => O[e.ref] ? c("a", { key: t.key, href: u(O[e.ref].target, "a", "href"), title: O[e.ref].title }, n(e.children, t)) : c("span", { key: t.key }, e.fallbackChildren) }, 25: { t: ["|"], o: T(ke), i: 1, u: _t, l(e, n, t) {
    const s = e;
    return c("table", { key: t.key }, c("thead", null, c("tr", null, s.header.map(function(o, a) {
      return c("th", { key: a, style: be(s, a) }, n(o, t));
    }))), c("tbody", null, s.cells.map(function(o, a) {
      return c("tr", { key: a }, o.map(function(g, k) {
        return c("td", { key: k, style: be(s, k) }, n(g, t));
      }));
    })));
  } }, 27: { o: I(function(e, n) {
    let t;
    return V(e, ":") && (t = kt.exec(e)), t || bt.exec(e);
  }), i: 4, u(e) {
    const n = e[0];
    return { text: n.indexOf("&") === -1 ? n : n.replace(Qe, (t, s) => i.namedCodesToUnicode[s] || t) };
  }, l: (e) => e.text }, 28: { t: ["**", "__"], o: E(gt), i: 2, u: (e, n, t) => ({ children: n(e[2], t) }), l: (e, n, t) => c("strong", { key: t.key }, n(e.children, t)) }, 29: { t: (e) => {
    const n = e[0];
    return (n === "*" || n === "_") && e[1] !== n;
  }, o: E(ht), i: 3, u: (e, n, t) => ({ children: n(e[2], t) }), l: (e, n, t) => c("em", { key: t.key }, n(e.children, t)) }, 30: { t: ["\\"], o: E(xt), i: 1, u: (e) => ({ text: e[1], type: "27" }) }, 31: { t: ["=="], o: E(mt), i: 3, u: ne, l: (e, n, t) => c("mark", { key: t.key }, n(e.children, t)) }, 32: { t: ["~~"], o: E(yt), i: 3, u: ne, l: (e, n, t) => c("del", { key: t.key }, n(e.children, t)) } };
  i.disableParsingRawHTML === !0 && (delete L[11], delete L[13]);
  const Z = (function(e) {
    var n = Object.keys(e);
    function t(s, o) {
      var a = [];
      if (o.prevCapture = o.prevCapture || "", s.trim()) for (; s; ) for (var g = 0; g < n.length; ) {
        var k = n[g], x = e[k];
        if (!x.t || Rt(s, o, x.t)) {
          var b = x.o(s, o);
          if (b && b[0]) {
            s = s.substring(b[0].length);
            var h = x.u(b, t, o);
            o.prevCapture += b[0], h.type || (h.type = k), a.push(h);
            break;
          }
          g++;
        } else g++;
      }
      return o.prevCapture = "", a;
    }
    return n.sort(function(s, o) {
      return e[s].i - e[o].i || (s < o ? -1 : 1);
    }), function(s, o) {
      return t((function(a) {
        return a.replace(qe, `
`).replace(Ve, "").replace(ut, "    ");
      })(s), o);
    };
  })(L), N = (W = /* @__PURE__ */ (function(e, n) {
    return function(t, s, o) {
      const a = e[t.type].l;
      return n ? n(() => a(t, s, o), t, s, o) : a(t, s, o);
    };
  })(L, i.renderRule), function e(n, t = {}) {
    if (Array.isArray(n)) {
      const s = t.key, o = [];
      let a = !1;
      for (let g = 0; g < n.length; g++) {
        t.key = g;
        const k = e(n[g], t), x = typeof k == "string";
        x && a ? o[o.length - 1] += k : k !== null && o.push(k), a = x;
      }
      return t.key = s, o;
    }
    return W(n, e, t);
  });
  var W;
  const H = f(r);
  return $.length ? c("div", null, H, c("footer", { key: "footer" }, $.map(function(e) {
    return c("div", { id: l(e.identifier, B), key: e.identifier }, e.identifier, N(Z(e.footnote, { inline: !0 })));
  }))) : H;
}
const Bt = (r) => {
  let { children: i = "", options: l } = r, u = (function(d, m) {
    if (d == null) return {};
    var p, c, f = {}, y = Object.keys(d);
    for (c = 0; c < y.length; c++) m.indexOf(p = y[c]) >= 0 || (f[p] = d[p]);
    return f;
  })(r, _e);
  return Ce.cloneElement(It(i, l), u);
};
export {
  It as compiler,
  Bt as default,
  jt as sanitizer,
  B as slugify
};
//# sourceMappingURL=index.es118.js.map
